/*
 * aa-moon-3d.js — GC28 (Fable)
 * Couche d'AFFICHAGE Three.js du studio lampe lune. Ne produit JAMAIS la référence
 * transmise (frontière = aa-moon-core.js). Chargée en tâche de fond (import() dynamique
 * de l'asset three vendorisé) — le premier rendu 2D n'attend jamais cette couche.
 * Garde-fous : WebGL absent → null ; watchdog perf (moy > 34 ms/frame sur 40 frames)
 * → onTooSlow() (le studio bascule sur le repli 2D). rAF gé par visibilité.
 */
(function () {
  'use strict';

  function webglOk() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }

  // Le minifieur d'assets du CDN Shopify transpile `import()` en `require()` (cassé navigateur).
  // Parade : module INLINE injecté (le HTML n'est pas minifié) qui importe three et le pose sur window.
  function importThree(url) {
    if (window.__AA_THREE) return Promise.resolve(window.__AA_THREE);
    if (window.__AA_THREE_P) return window.__AA_THREE_P;
    window.__AA_THREE_P = new Promise(function (ok, ko) {
      var abs = url.indexOf('//') === 0 ? (location.protocol + url) : url;
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = "import * as T from '" + abs.replace(/'/g, '') + "'; window.__AA_THREE = T; document.dispatchEvent(new Event('aa:three-ready'));";
      var t = setTimeout(function () { if (!window.__AA_THREE) ko(new Error('three timeout')); }, 20000);
      document.addEventListener('aa:three-ready', function h() {
        document.removeEventListener('aa:three-ready', h);
        clearTimeout(t);
        window.__AA_THREE ? ok(window.__AA_THREE) : ko(new Error('three vide'));
      });
      document.head.appendChild(s);
    });
    return window.__AA_THREE_P;
  }
  function create(container, opts) {
    if (!webglOk()) return Promise.resolve(null);
    return importThree(opts.threeUrl).then(function (THREE) {
      try { return build(THREE, container, opts); } catch (e) { console.warn('[aa-moon-3d] build', e); return null; }
    }).catch(function (e) { console.warn('[aa-moon-3d] import three', e); return null; });
  }

  function build(THREE, container, opts) {
    // Canvas au format du conteneur (portrait mobile / paysage desktop) : la lampe remplit la HAUTEUR,
    // le surplus de largeur = ciel pour les outils (retour fondateur 5 — zéro chevauchement sur la lune)
    var W = Math.min(1600, container.clientWidth || 560);
    var H = (container.clientHeight && container.clientHeight > 40) ? Math.min(1600, container.clientHeight) : W;
    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }); // pas de preserveDrawingBuffer : snapshot() re-rend juste avant toDataURL (même tick = valide)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(W, H);
    renderer.domElement.className = 'aa-moon-gl';
    renderer.domElement.style.touchAction = 'pan-y'; // le scroll VERTICAL reste natif (stage sticky mobile ≠ zone morte) ; drag horizontal = rotation
    container.appendChild(renderer.domElement);

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(33, W / H, 0.1, 30);
    // cadrage (retour fondateur 8, recalibré par MESURE) : le bord AVANT du socle/de l'ombre est le point
    // le plus bas projeté — accessoires compactés + caméra recalée → marges réelles haut ~2 % / bas ~4 %
    camera.position.set(0, 0.24, 4.35);
    camera.lookAt(0, 0, 0);

    var ambient = new THREE.AmbientLight(0xffffff, 0.85);
    var key = new THREE.DirectionalLight(0xfff2e2, 0.95);
    key.position.set(2.2, 1.6, 2.6);
    var rim = new THREE.DirectionalLight(0xbfd0ff, 0.22);
    rim.position.set(-2.4, 0.8, -1.8);
    scene.add(ambient, key, rim);

    var group = new THREE.Group(); scene.add(group);

    var dispTex = null;
    if (opts.dispImg) {
      dispTex = new THREE.Texture(opts.dispImg); dispTex.needsUpdate = true;
    }
    var mat = new THREE.MeshStandardMaterial({
      color: 0xffffff, roughness: 0.96, metalness: 0,
      emissive: new THREE.Color(opts.color || '#ffd9a0'), emissiveIntensity: 0,
      displacementMap: dispTex || undefined, displacementScale: dispTex ? 0.035 : 0,
      bumpMap: dispTex || undefined, bumpScale: dispTex ? 0.9 : 0
    });
    // 96×96 segments : assez pour le relief displacement, léger pour mobile (~18k sommets)
    var sphere = new THREE.Mesh(new THREE.SphereGeometry(1, 96, 96), mat);
    sphere.position.y = 0.18;
    group.add(sphere);

    // Socle bois sombre stylisé + ombre douce
    var baseMat = new THREE.MeshStandardMaterial({ color: 0x3a2c20, roughness: 0.55, metalness: 0.08 });
    var base = new THREE.Mesh(new THREE.CylinderGeometry(0.40, 0.48, 0.16, 48), baseMat); // compact : son bord avant ne plonge plus sous le cadre
    base.position.y = -0.96;
    var ring = new THREE.Mesh(new THREE.TorusGeometry(0.41, 0.02, 12, 48), new THREE.MeshStandardMaterial({ color: 0x8a6f4d, roughness: 0.35, metalness: 0.55 }));
    ring.rotation.x = Math.PI / 2; ring.position.y = -0.875;
    group.add(base, ring);
    var shadowCv = document.createElement('canvas'); shadowCv.width = 256; shadowCv.height = 256;
    var sx = shadowCv.getContext('2d');
    var g = sx.createRadialGradient(128, 128, 10, 128, 128, 120);
    g.addColorStop(0, 'rgba(0,0,0,0.42)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    sx.fillStyle = g; sx.fillRect(0, 0, 256, 256);
    var shadowTex = new THREE.CanvasTexture(shadowCv);
    var shadow = new THREE.Mesh(new THREE.PlaneGeometry(1.5, 1.5), new THREE.MeshBasicMaterial({ map: shadowTex, transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.set(0, -1.05, -0.3); // recentrée vers l'ARRIÈRE : son bord avant ne perce plus le bas du cadre
    scene.add(shadow);

    // ── État & API ──
    // FRONT : offset UV de SphereGeometry — rotY=-π/2 place le centre de la texture (lon 0 = zone photo) face caméra (calibré en réel GC28)
    var FRONT = -Math.PI / 2;
    var st = {
      lit: false, litT: 0,               // litT 0..1 animé (allumage progressif)
      color: opts.color || '#ffd9a0',
      rotY: FRONT, rotX: 0, velY: 0, velX: 0,
      dragging: false, lastX: 0, lastY: 0, lastT: 0,
      idleAt: performance.now() + 2200,  // spin lent après 2,2 s sans interaction
      targetY: null,                     // spinTo (ex. montrer le verso)
      visible: true, destroyed: false, frames: 0, frameAcc: 0, watchdogDone: false
    };

    var mapTex = null, emTex = null;
    function setMaps(mapCanvas, emissiveCanvas) {
      if (st.destroyed) return;
      // mêmes canvases réutilisés côté core → simple re-upload GPU (needsUpdate), pas de nouvelle texture
      if (mapTex && mapTex.image === mapCanvas && emTex && emTex.image === emissiveCanvas) {
        mapTex.needsUpdate = true; emTex.needsUpdate = true; kick(); return;
      }
      if (mapTex) mapTex.dispose();
      if (emTex) emTex.dispose();
      mapTex = new THREE.CanvasTexture(mapCanvas);
      emTex = new THREE.CanvasTexture(emissiveCanvas);
      if (THREE.SRGBColorSpace) { mapTex.colorSpace = THREE.SRGBColorSpace; emTex.colorSpace = THREE.SRGBColorSpace; }
      mat.map = mapTex; mat.emissiveMap = emTex; mat.needsUpdate = true;
      kick();
    }
    function setColor(hex) { st.color = hex; mat.emissive.set(hex); kick(); }
    function setLit(on) { st.lit = !!on; st.idleAt = performance.now() + 2200; kick(); }
    // hold = personnalisation en cours : la lune reste IMMOBILE (spin auto coupé), reprend à la fermeture (retour fondateur 4)
    function setHold(v) { st.hold = !!v; if (!v) st.idleAt = performance.now() + 1600; kick(); }
    function spinTo(deg) {
      // deg exprimé en longitude TEXTURE (0 = photo face caméra, 180 = verso/texte) ; chemin angulaire le plus court
      var target = FRONT + deg * Math.PI / 180, twoPi = Math.PI * 2;
      st.targetY = target + Math.round((st.rotY - target) / twoPi) * twoPi;
      st.idleAt = performance.now() + 5200; kick();
    }

    // ── Gestes : rotation au doigt avec inertie. Cible = LE CANVAS UNIQUEMENT
    //    (L8 : les boutons overlay du stage sont hors canvas → jamais avalés par la capture).
    var cvEl = renderer.domElement;
    cvEl.addEventListener('pointerdown', function (e) {
      st.dragging = true; st.velY = 0; st.velX = 0; st.targetY = null;
      st.lastX = e.clientX; st.lastY = e.clientY; st.lastT = performance.now();
      st.downX = e.clientX; st.downY = e.clientY;
      try { cvEl.setPointerCapture(e.pointerId); } catch (err) {}
      kick();
    });
    cvEl.addEventListener('pointermove', function (e) {
      if (!st.dragging) return;
      var now = performance.now(), dt = Math.max(8, now - st.lastT);
      var dx = e.clientX - st.lastX, dy = e.clientY - st.lastY;
      st.rotY += dx * 0.0062; st.rotX = clamp(st.rotX + dy * 0.0034, -0.6, 0.6);
      st.velY = (dx * 0.0062) * (16 / dt); st.velX = (dy * 0.0034) * (16 / dt);
      st.lastX = e.clientX; st.lastY = e.clientY; st.lastT = now;
      st.idleAt = now + 2600;
    });
    function endDrag(e) {
      if (!st.dragging) return;
      st.dragging = false;
      var moved = Math.abs(e.clientX - st.downX) + Math.abs(e.clientY - st.downY);
      if (moved < 7 && opts.onTap) opts.onTap(); // tap sur la lune (interrupteur, comme la vraie lampe tactile)
    }
    cvEl.addEventListener('pointerup', endDrag);
    cvEl.addEventListener('pointercancel', function () { st.dragging = false; });

    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

    // ── Boucle : rAF actif seulement si visible + onglet au premier plan ──
    var rafId = 0, running = false;
    function kick() { if (!running && !st.destroyed && st.visible && !document.hidden) { running = true; rafId = requestAnimationFrame(loop); } }
    var lastFrame = 0;
    function loop(t) {
      running = false;
      if (st.destroyed || !st.visible || document.hidden) return;
      var dt = lastFrame ? Math.min(50, t - lastFrame) : 16; lastFrame = t;

      // allumage progressif (l'instant signature : ~900 ms)
      var target = st.lit ? 1 : 0;
      if (Math.abs(st.litT - target) > 0.001) {
        st.litT += (target - st.litT) * Math.min(1, dt / 240);
        if (Math.abs(st.litT - target) < 0.012) st.litT = target;
      }
      var e = st.litT * st.litT * (3 - 2 * st.litT); // smoothstep
      mat.emissiveIntensity = 1.5 * e;
      ambient.intensity = 0.85 - 0.58 * e;   // la pièce s'assombrit quand la lampe s'allume
      key.intensity = 0.95 - 0.62 * e;
      rim.intensity = 0.22 + 0.1 * e;
      if (opts.onAmbiance && Math.abs(e - (st._lastE == null ? -1 : st._lastE)) > 0.004) { st._lastE = e; opts.onAmbiance(e); } // DOM touché seulement quand ça change

      // rotation : inertie / spinTo / spin lent idle
      if (!st.dragging) {
        if (st.targetY != null) {
          var d = st.targetY - st.rotY;
          st.rotY += d * Math.min(1, dt / 260);
          if (Math.abs(d) < 0.01) { st.rotY = st.targetY; st.targetY = null; }
        } else {
          st.rotY += st.velY * dt; st.rotX = clamp(st.rotX + st.velX * dt, -0.6, 0.6);
          st.velY *= Math.pow(0.94, dt / 16); st.velX *= Math.pow(0.9, dt / 16);
          if (Math.abs(st.velY) < 0.00004) st.velY = 0;
          if (Math.abs(st.velX) < 0.00004) st.velX = 0;
          if (t > st.idleAt && !st.hold) st.rotY += 0.00012 * dt; // respiration lente (coupée pendant la perso — hold)
          st.rotX += (0 - st.rotX) * Math.min(1, dt / 2400) * (st.velX ? 0 : 1) * 0.4;
        }
      }
      sphere.rotation.y = st.rotY; sphere.rotation.x = st.rotX;

      var isActive = st.dragging || st.velY || st.velX || st.targetY != null || Math.abs(st.litT - target) > 0.001;
      // IDLE (respiration seule) : 1 frame sur 2 rendue (≈30 fps) — batterie/chauffe sur stage sticky
      if (!isActive) { st._skip = !st._skip; if (st._skip) { kick(); return; } }
      renderer.render(scene, camera);
      // watchdog perf : delta INTER-FRAMES rAF (le GPU est asynchrone — mesurer le CPU de render() ne voit pas un mobile GPU-bound).
      // 48 deltas après textures posées, on saute les 6 premiers (compilation shaders) ; > 30 % de frames au-delà de ~2 frames 30 fps → repli 2D.
      if (!st.watchdogDone && mat.map) {
        st.frames++;
        if (st.frames > 6 && dt > 66) st.frameAcc++;
        if (st.frames >= 48) {
          st.watchdogDone = true;
          if (st.frameAcc / (st.frames - 6) > 0.3 && opts.onTooSlow) { opts.onTooSlow(); return; }
        }
      }
      kick(); // respiration continue tant que visible — coût borné par IntersectionObserver + document.hidden + skip idle
    }

    var io = null;
    try {
      io = new IntersectionObserver(function (en) {
        st.visible = !!(en[0] && en[0].isIntersecting);
        if (st.visible) kick();
      }, { threshold: 0.05 });
      io.observe(container);
    } catch (e) {}
    var onVis = function () { if (!document.hidden) kick(); };
    document.addEventListener('visibilitychange', onVis);

    var ro = null;
    try {
      ro = new ResizeObserver(function () {
        var w = Math.min(1600, container.clientWidth || W);
        var h = (container.clientHeight && container.clientHeight > 40) ? Math.min(1600, container.clientHeight) : w;
        if (w > 40) { renderer.setSize(w, h); camera.aspect = w / h; camera.updateProjectionMatrix(); kick(); }
      });
      ro.observe(container);
    } catch (e) {}

    function snapshot() {
      try { renderer.render(scene, camera); return renderer.domElement.toDataURL('image/png'); } catch (e) { return null; }
    }
    // preuve/debug : rend UNE frame SYNCHRONE hors rAF (les onglets automatisés gèlent rAF — leçon 16/07)
    function renderOnce() {
      var target = st.lit ? 1 : 0; st.litT = target;
      var e = target;
      mat.emissiveIntensity = 1.5 * e;
      ambient.intensity = 0.85 - 0.58 * e; key.intensity = 0.95 - 0.62 * e; rim.intensity = 0.22 + 0.1 * e;
      if (opts.onAmbiance) opts.onAmbiance(e);
      sphere.rotation.y = st.rotY; sphere.rotation.x = st.rotX;
      renderer.render(scene, camera);
      return true;
    }
    function destroy() {
      st.destroyed = true;
      cancelAnimationFrame(rafId);
      if (io) io.disconnect();
      if (ro) ro.disconnect();
      document.removeEventListener('visibilitychange', onVis);
      try {
        sphere.geometry.dispose(); base.geometry.dispose(); ring.geometry.dispose(); shadow.geometry.dispose();
        mat.dispose(); baseMat.dispose(); shadowTex.dispose();
        if (mapTex) mapTex.dispose(); if (emTex) emTex.dispose(); if (dispTex) dispTex.dispose();
        if (renderer.forceContextLoss) renderer.forceContextLoss();
        renderer.dispose();
      } catch (e) {}
      if (cvEl.parentNode) cvEl.parentNode.removeChild(cvEl);
    }

    kick();
    return { setMaps: setMaps, setLit: setLit, setColor: setColor, spinTo: spinTo, setHold: setHold, snapshot: snapshot, renderOnce: renderOnce, destroy: destroy, canvas: cvEl, _st: st };
  }

  window.AAMoon3D = { create: create, webglOk: webglOk };
})();
